<template>
  <async-btn
    :task="task"
    icon="fa fa-question"
    label="I Need Help"
    color="dark"
    size="lg"
    v-bind="$attrs"
    rounded
    no-caps
    unelevated
    @click="requestSupport"
  />
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { Platform, ReconnectRequest } from '../../../types';
import { requestSupport } from '.';

interface Data {
  task: Promise<ReconnectRequest>|null,
}

export default defineComponent({
  emits: ['done'],
  components: { AsyncBtn },
  props: {
    platform: {
      type: Object as () => Platform,
      required: true,
    },
    getAccountId: {
      type: Function as PropType<() => Promise<number>>,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    requestSupport() {
      this.task = this.getAccountId().then(accountId => requestSupport(accountId));
      this.task.then(() => {
        this.$emit('done');
      });
    },
  },
});
</script>
